export default (function (message) {
  if (process && process.env && process.env.NODE_ENV !== 'production') {
    console && console.warn && console.warn(message);
  }
});
//# sourceMappingURL=warn.js.map